import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Preloader } from './components/Preloader';
import { Hero } from './components/Hero';
import { Welcome } from './components/Welcome';
import { Destinations } from './components/Destinations';
import { Training } from './components/Training';
import { Footer } from './components/Footer';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  const [isLoading, setIsLoading] = useState(true);
  return <div className="min-h-screen bg-zinc-950 font-sans text-white selection:bg-blue-900 selection:text-white" data-id="element-0">
      <AnimatePresence data-id="element-1">
        {isLoading && <Preloader onComplete={() => setIsLoading(false)} data-id="element-2" />}
      </AnimatePresence>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: isLoading ? 0 : 1
    }} transition={{
      duration: 1,
      ease: 'easeInOut'
    }} data-id="element-3">
        <Hero data-id="element-4" />
        <Welcome data-id="element-5" />
        <Destinations data-id="element-6" />
        <Training data-id="element-7" />
        <Footer data-id="element-8" />
      </motion.div>
    </div>;
}